import cx from '@utils/cx.util';
import Digits from './Digits';

type Props = {
  value: number;
  label: string;
  hideIfZero?: boolean;
  className?: string;
  labelClassName?: string;
  digitClassName?: string;
  digitContainerClassName?: string;
};

const CountdownBox = ({
  value,
  label,
  hideIfZero,
  className,
  labelClassName,
  digitClassName,
  digitContainerClassName,
}: Props) => {
  if (hideIfZero && value === 0) return null;

  return (
    <div className={cx('tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1', className)}>
      <div
        className={cx(
          'tw-rounded-md tw-bg-white tw-px-2 tw-py-[0.35rem] tw-text-neutral-950',
          digitContainerClassName
        )}>
        <Digits value={value} className={cx('tw-font-mono tw-font-bold', digitClassName)} />
      </div>
      <span className={cx('tw-text-[10px] tw-text-white md:tw-text-xs', labelClassName)}>{label}</span>
    </div>
  );
};

export default CountdownBox;
